import { ClassData } from '@/types/class';
import { gql } from '@apollo/client';

export interface GetClassesResponse {
    classes: ClassData[];
    classesCount: number;
}

export const GET_CLASSES = gql`
    query GetClasses($skip: Int!, $take: Int!, $orderBy: [ClassOrderByInput!], $where: ClassWhereInput) {
        classes(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
            id
            name
            className
            studentsCount(where: { NOT: [{ user: null }] })
            schoolYear
        }
        classesCount(where: $where)
    }
`;

export type CreateClassResponse = {
    createClass: ClassData;
};

export const CREATE_CLASS = gql`
    mutation CreateClass($data: ClassCreateInput!) {
        createClass(data: $data) {
            id
            className
            schoolYear
            studentsCount(where: { NOT: [{ user: null }] })
        }
    }
`;

export type UpdateClassResponse = {
    updateClass: ClassData;
};

export const UPDATE_CLASS = gql`
    mutation UpdateClass($data: ClassUpdateInput!, $where: ClassWhereUniqueInput!) {
        updateClass(data: $data, where: $where) {
            id
            className
            schoolYear
            studentsCount(where: { NOT: [{ user: null }] })
        }
    }
`;
